import dragButton from "../../../assets/img/TicketCard/dragButton.svg";
import { Draggable } from "react-beautiful-dnd";
import { dashboardColors, theme } from "../../../themes/Theme";

const IndividualTagComponent = ({
	tagData,
	index,
	tagText,
	editIcon,
	editClickHandler,
	deleteIcon,
	deleteClickHandler,
	isDragDisabled = false
}) => {
	return (
		<>
			<Draggable
				key={String(tagData?.id)}
				draggableId={String(tagData?.id)}
				index={index}
				isDragDisabled={isDragDisabled}
			>
				{provided => (
					<div ref={provided.innerRef} {...provided.draggableProps} className="my-1">
						<span className="tag-border">
							{!isDragDisabled && (
								<span className="ml-2">
									<img
										{...provided.dragHandleProps}
										className="text-center dragCus"
										src={dragButton}
									/>
								</span>
							)}
							<span className="pr-2 ml-2">{tagText}</span>
							<span className="tag-divider pr-2">|</span>
							{editIcon && (
								<span className="pr-2">
									<i
										style={{
											fontSize: "14px",
											transform: "translateY(2px)",
											color:'#002e6e',
										}}
										onClick={editClickHandler}
										className="iconSize fas fa-pen"
									></i>
								</span>
							)}
							{deleteIcon && (
								<span className="pr-2 deleteIconStyles">
									<i
										style={{ color: dashboardColors[theme].primary, fontSize: "14px" }}
										className="fas fa-trash text-danger"
										onClick={deleteClickHandler}
									></i>
								</span>
							)}
						</span>
					</div>
				)}
			</Draggable>
			<style>
				{`
					.tag-border{
						color: ${dashboardColors[theme].primaryTextColor};
						font-size: 14px;
						font-weight: 400;
						border: 1px solid  ${dashboardColors[theme].primary};
						border-radius: 2px;
						margin-right: 10px;
					}
					.tag-divider{
						color: ${dashboardColors[theme].primaryTextColor};
					}
					.deleteIconStyles{
						vertical-align: middle;
						display: inline-flex;
					}
					.dragCus {
						color:  ${dashboardColors[theme].primaryTextColor};
						width: 6.3px;
						margin: 2px;
					}
				`}
			</style>
		</>
	);
};

export default IndividualTagComponent;
